import { usingGet } from '@ocean/api'

// TODO: Just stub. Use correct endpoint
export const getData = () => usingGet('AproDetails/GetData')
